<template>
  <v-snackbar
    v-model="show"
    multi-line
    right
    :timeout="2000"
    :color="color"
    style="z-index: 1008 !important"
  >
    <span>
      <v-icon left>mdi-check</v-icon>
      {{ mensaje }}
    </span>
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        @click="show = false"
        small
        class="float-right"
        v-bind="attrs"
      >
        <v-icon class="float-right">mdi-close-circle</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  name: "Snackbar",
  props: ["value", "mensaje", "color"],
  data: function () {
    return {
      show: false,
      timeout: 2000,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.show = val;
      },
      // deep: true,
    },
    // color: function () {
    //   this.$emit("input", { show: this.show });
    // },
  },
};
</script>